export const STEP_CHOOSE_SOURCE_EVENTS = "chooseSourceEvent";
export const STEP_TYPE_OF_NOTIFICATION = "typeOfNotification";
export const STEP_FILTER_RECEIVERS = "filterReceivers";
export const STEP_NOTIFICATION_CONTENT = "notificationContent";
export const STEP_REVIEW_RECEIVERS = "reviewReceivers";
export const STEP_COST_CALCULATION = "costCalculation";
export const STEP_SCHEDULE_SENDING = "scheduleSending";

export const NOTIFICATION_NONE = "none";
export const NOTIFICATION_SMS = "sms";
export const NOTIFICATION_EMAIL = "email";
export const NOTIFICATION_INTERNAL = "internal";
